<template>
    <span>Bienvenido</span>
</template>
<script>
  export default {
    name: 'notification-sample'
  }
</script>
<style>
</style>
